import React from "react";
import { createRoot } from "react-dom/client";

import Globe from "../components/Globe";

const domContainer = document.querySelector("#globe_container");
if (domContainer) {
  const root = createRoot(domContainer);
  root.render(React.createElement(Globe));
}
